import { UseFormReturn } from 'react-hook-form';
import { IFieldElem } from '@models/IFormData';
import { useEffect } from 'react';

/**
 * Снимает ошибку с поля, ставшего необязательным. `requiredSettled` — правило required уже
 * вычислено: до этого `required` — стартовое `false`, и контрол, смонтированный после
 * неудачного сабмита (непосещённая вкладка), стёр бы только что выставленную ошибку.
 */
export function useClearErrorOnOptional(
    required: boolean,
    requiredSettled: boolean,
    formMethods: UseFormReturn<any>,
    dataField: IFieldElem | undefined,
) {
    useEffect(() => {
        // getFieldState, а не formState.errors: чтение errors через formState подписало бы корень формы (карточку
        // документа) на каждую смену ошибок — проверка формы и правка таблицы перерисовывали бы весь документ
        if (
            requiredSettled &&
            !required &&
            dataField &&
            formMethods.getFieldState(`fields.${dataField.index}`).invalid
        ) {
            formMethods.clearErrors(dataField.name as any);
        }
    }, [required, requiredSettled, formMethods, dataField]);
}
